<template>
  <div>
    <v-container>
      <v-card class="rounded-xl elevation-4">
        <!-- Cabeçalho com Abas -->
        <v-tabs
          v-model="tab"
          grow
          background-color="primary"
          dark
        >
          <v-tab>
            <v-icon left>mdi-doctor</v-icon>
            Médicos da Unidade
          </v-tab>
          <v-tab>
            <v-icon left>mdi-package-variant</v-icon>
            Pacote de Exames
          </v-tab>
          <v-tab>
            <v-icon left>mdi-test-tube</v-icon>
            Pacote Laboratorial
          </v-tab>
        </v-tabs>

        <!-- Conteúdo das Abas -->
        <v-tabs-items v-model="tab">
          <!-- ABA 1: Médicos da Unidade -->
          <v-tab-item>
            <v-card flat>
              <v-card-title class="d-flex align-center">
                <div>
                  <div class="text-h6">Médicos ativos</div>
                  <div class="caption grey--text">Gerencie cadastro e vínculos</div>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchAtivo"
                  append-icon="mdi-magnify"
                  label="Buscar médico"
                  single-line
                  hide-details
                  class="mb-4"
                ></v-text-field>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="listaFuncionariosAtivos"
                :search="searchAtivo"
                no-data-text="Nenhum médico cadastrado"
              >
                <template v-slot:no-data>
                  <v-alert type="info" border="left" colored-border text>
                    Nenhum médico encontrado. Clique em “+” para cadastrar.
                  </v-alert>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" @click="cadastrarMedicoExame(item)" color="primary">
                        <v-icon>mdi-file-document-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar exames</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" @click="cadastrarMedicoServico(item)" color="primary" class="ml-2">
                        <v-icon>mdi-hospital-building</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar serviços</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" @click="alterarDadosMedico(item)" color="primary" class="ml-2">
                        <v-icon>mdi-account-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar dados</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <v-btn
                color="primary"
                fab
                dark
                fixed
                bottom
                right
                @click="cadastrarMedico"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card>
          </v-tab-item>

          <!-- ABA 2: Pacote de Exames -->
          <v-tab-item>
            <v-card flat>
              <v-card-title class="d-flex align-center">
                <div>
                  <div class="text-h6">Pacotes clínicos</div>
                  <div class="caption grey--text">Agrupe exames e vincule médicos</div>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="filtroBusca"
                  prepend-icon="mdi-magnify"
                  placeholder="Buscar pacote"
                  hide-details
                ></v-text-field>
              </v-card-title>

              <v-card-text>
                <v-progress-linear
                  v-if="loadPacotes"
                  indeterminate
                  color="primary"
                ></v-progress-linear>

                <v-alert v-else-if="pacotesExamesFiltrados.length === 0" type="info" border="left" colored-border text>
                  Nenhum pacote encontrado. Clique em “+” para criar um novo pacote.
                </v-alert>

                <v-row v-else>
                  <v-col
                    v-for="(item, i) in pacotesExamesFiltrados"
                    :key="i"
                    cols="12" md="6" lg="4"
                  >
                    <v-card class="pa-4" outlined>
                      <v-card-title class="subtitle-1 primary--text">
                        {{ item.nome }}
                        <v-spacer></v-spacer>
                        <v-chip small color="primary" text-color="white">
                          {{ item.exames.length }} exame(s)
                        </v-chip>
                      </v-card-title>

                      <v-card-text>
                        <div v-for="(it,j) in item.exames.slice(0,2)" :key="j" class="mb-1">
                          <v-icon small>mdi-check</v-icon> {{ it.apelido }}
                        </div>
                        <div v-if="item.exames.length > 2" class="caption grey--text">
                          + {{ item.exames.length - 2 }} exames
                        </div>
                      </v-card-text>

                      <v-card-actions class="justify-end">
                        <v-btn icon @click="exibirVincularMedicos(item)" color="success">
                          <v-icon>mdi-doctor</v-icon>
                        </v-btn>
                        <v-btn icon @click="exibirEditarPacote(item)" color="warning">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="isRemovePacote = true; pacoteSelecionado = item" color="error">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>

                <v-btn
                  color="primary"
                  fab
                  dark
                  fixed
                  bottom
                  right
                  @click="isAddPacote = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- ABA 3: Pacote Laboratorial -->
          <v-tab-item>
            <v-card flat>
              <v-card-title class="d-flex align-center">
                <div>
                  <div class="text-h6">Pacotes laboratoriais</div>
                  <div class="caption grey--text">Exames de laboratório organizados por pacote</div>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="filtroBusca"
                  prepend-icon="mdi-magnify"
                  placeholder="Buscar pacote"
                  hide-details
                ></v-text-field>
              </v-card-title>

              <v-card-text>
                <v-progress-linear
                  v-if="loadPacotes"
                  indeterminate
                  color="primary"
                ></v-progress-linear>

                <v-alert v-else-if="pacotesExamesFiltrados.length === 0" type="info" border="left" colored-border text>
                  Nenhum pacote encontrado. Clique em “+” para criar um novo pacote.
                </v-alert>

                <v-row v-else>
                  <v-col
                    v-for="(item, i) in pacotesExamesFiltrados"
                    :key="i"
                    cols="12" md="6" lg="4"
                  >
                    <v-card class="pa-4" outlined>
                      <v-card-title class="subtitle-1 primary--text">
                        {{ item.nome }}
                        <v-spacer></v-spacer>
                        <v-chip small color="primary" text-color="white">
                          {{ item.exames.length }} exame(s)
                        </v-chip>
                      </v-card-title>

                      <v-card-text>
                        <div v-for="(it,j) in item.exames.slice(0,2)" :key="j" class="mb-1">
                          <v-icon small>mdi-check</v-icon> {{ it.apelido }}
                        </div>
                        <div v-if="item.exames.length > 2" class="caption grey--text">
                          + {{ item.exames.length - 2 }} exames
                        </div>
                      </v-card-text>

                      <v-card-actions class="justify-end">
                        <v-btn icon @click="exibirVincularMedicos(item)" color="success">
                          <v-icon>mdi-doctor</v-icon>
                        </v-btn>
                        <v-btn icon @click="exibirEditarPacote(item)" color="warning">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="isRemovePacote = true; pacoteSelecionado = item" color="error">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>

                <v-btn
                  color="primary"
                  fab
                  dark
                  fixed
                  bottom
                  right
                  @click="isAddPacote = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- DIÁLOGOS -->
      <!-- Diálogo Cadastrar Pacote -->
      <v-dialog v-model="isAddPacote" max-width="800" persistent>
        <v-card>
          <v-card-title class="headline">
            <v-icon left>mdi-package-variant-plus</v-icon>
            Novo Pacote de Exames
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="nomePacote"
                label="Nome do pacote"
                :rules="nameRules"
                outlined
                class="mb-4"
              ></v-text-field>

              <v-autocomplete
                v-model="exameSelecionado"
                :items="exames"
                :loading="isLoading"
                :search-input.sync="searchExame"
                item-text="apelido"
                item-value="idExame"
                label="Buscar exames"
                prepend-icon="mdi-magnify"
                hint="Digite para buscar e selecione para adicionar"
                persistent-hint
                no-data-text="Nenhum exame encontrado"
                return-object
                outlined
                :rules="examesRules"
              ></v-autocomplete>
            </v-form>

            <v-card v-if="listaExames.length > 0" flat outlined class="mt-4" style="max-height: 300px; overflow-y: auto;">
              <v-card-title class="subtitle-2">
                Exames selecionados ({{ listaExames.length }})
              </v-card-title>
              <v-list dense>
                <v-list-item v-for="(item, i) in listaExames" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.apelido }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="listaExames.splice(i, 1)" color="error">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn text @click="isAddPacote = false; listaExames = []" class="mr-2">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="cadastrarPacoteExame()"
              :loading="loadCadastro"
              :disabled="!valid"
            >
              Cadastrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Editar Pacote -->
      <v-dialog v-model="isEditarPacote" max-width="800" persistent>
        <v-card>
          <v-card-title class="headline">
            <v-icon left>mdi-pencil</v-icon>
            Editar Pacote: {{ pacoteSelecionado.nome }}
          </v-card-title>

          <v-card-text>
            <v-form ref="formEdit" v-model="validEdit">
              <v-text-field
                v-model="pacoteSelecionado.nome"
                label="Nome do pacote"
                :rules="nameRules"
                outlined
                class="mb-4"
              ></v-text-field>

              <v-autocomplete
                v-model="exameSelecionado"
                :items="exames"
                :loading="isLoading"
                :search-input.sync="searchExame"
                item-text="apelido"
                item-value="idExame"
                label="Adicionar exames"
                prepend-icon="mdi-magnify"
                hint="Digite para buscar e selecione para adicionar"
                persistent-hint
                no-data-text="Nenhum exame encontrado"
                return-object
                outlined
              ></v-autocomplete>
            </v-form>

            <v-card flat outlined class="mt-4" style="max-height: 300px; overflow-y: auto;">
              <v-card-title class="subtitle-2">
                Exames do pacote ({{ listaExames.length }})
              </v-card-title>
              <v-list dense>
                <v-list-item v-for="(item, i) in listaExames" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.apelido }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="listaExames.splice(i, 1)" color="error">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn text @click="isEditarPacote = false; listaExames = []" class="mr-2">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="editarPacoteExame()"
              :loading="loadEdit"
            >
              Salvar Alterações
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Vincular Médicos -->
      <v-dialog v-model="isVincularMedicos" max-width="800" persistent>
        <v-card>
          <v-card-title class="headline">
            <v-icon left>mdi-account-multiple-plus</v-icon>
            Vincular Médicos ao Pacote: {{ pacoteSelecionado.nome }}
          </v-card-title>

          <v-card-text>
            <v-autocomplete
              v-model="medicosSelecionados"
              :items="listaFuncionariosAtivos"
              label="Selecionar médicos"
              multiple
              item-text="nome"
              item-value="idMedico"
              chips
              deletable-chips
              outlined
            ></v-autocomplete>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn text @click="isVincularMedicos = false; medicosSelecionados = []" class="mr-2">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="cadastrarPacoteMedico()"
              :loading="loadVinculacao"
            >
              Vincular Médicos
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Confirmar Exclusão -->
      <v-dialog v-model="isRemovePacote" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar Exclusão
          </v-card-title>
          <v-card-text>
            Tem certeza que deseja remover o pacote "{{ pacoteSelecionado.nome }}"?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="isRemovePacote = false">
              Cancelar
            </v-btn>
            <v-btn color="error" text @click="removerPacoteExame(pacoteSelecionado); isRemovePacote = false">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbars de Feedback -->
      <v-snackbar
        v-model="cadastroSucesso"
        color="success"
        timeout="3000"
      >
        <v-icon left>mdi-check-circle</v-icon>
        Pacote criado com sucesso!
      </v-snackbar>

      <v-snackbar
        v-model="editarSucesso"
        color="success"
        timeout="3000"
      >
        <v-icon left>mdi-check-circle</v-icon>
        Pacote atualizado com sucesso!
      </v-snackbar>

      <v-snackbar
        v-model="vincularSucesso"
        color="success"
        timeout="3000"
      >
        <v-icon left>mdi-check-circle</v-icon>
        Médicos vinculados com sucesso!
      </v-snackbar>

      <v-snackbar
        v-model="removerSucesso"
        color="success"
        timeout="3000"
      >
        <v-icon left>mdi-check-circle</v-icon>
        Pacote removido com sucesso!
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import medicoService from '../../../services/medico.service'

export default {
  name: 'GerenciamentoMedicosPacotes',
  data () {
    return {
      tab: null,
      searchAtivo: '',
      searchDesativo: '',
      listaFuncionariosAtivos: [],
      listaAtendentesAtivos: [],
      atendentesSelecionados: null,
      headers: [
        { text: 'Nome do Médico', value: 'nome', align: 'center', sortable: true },
        { text: 'Ações', value: 'actions', align: 'center', sortable: false }
      ],

      // Dados para pacotes de exames
      pacotesExames: [],
      filtroBusca: '',
      loadPacotes: false,
      sadt: false,

      // Diálogos
      isAddPacote: false,
      isEditarPacote: false,
      isVincularMedicos: false,
      isRemovePacote: false,

      // Formulários
      valid: false,
      validEdit: false,
      nomePacote: '',
      listaExames: [],
      exameSelecionado: null,
      searchExame: '',
      isLoading: false,
      entries: [],

      // Pacote selecionado
      pacoteSelecionado: {
        _id: '',
        nome: '',
        exames: [],
        medicos: [],
        idUnidade: '',
        sadt: false
      },

      // Médicos selecionados
      medicosSelecionados: [],

      // Feedback
      cadastroSucesso: false,
      editarSucesso: false,
      vincularSucesso: false,
      removerSucesso: false,

      // Loadings
      loadCadastro: false,
      loadEdit: false,
      loadVinculacao: false,

      // Regras de validação
      nameRules: [
        v => !!v || 'O nome é obrigatório',
        v => (v && v.length >= 3) || 'Nome deve ter pelo menos 3 caracteres'
      ],
      examesRules: [
        v => (Array.isArray(this.listaExames) && this.listaExames.length > 0 || 'Selecione pelo menos um exame')
      ]
    }
  },
  computed: {
    pacotesExamesFiltrados () {
      if (!this.filtroBusca) return this.pacotesExames
      const busca = this.filtroBusca.toLowerCase()
      return this.pacotesExames.filter(item =>
        item.nome.toLowerCase().includes(busca))
    },
    exames () {
      return (this.entries || []).map(entry => ({
        ...entry,
        Description: entry.nome.length > 50
          ? entry.nome.slice(0, 47) + '...'
          : entry.nome
      }))
    }
  },
  watch: {
    tab (val) {
      this.sadt = val === 2
      this.listarPacoteExames()
    },
    searchExame (val) {
      if (val && val.trim().length > 0) {
        this.listarExames(val)
      }
    },
    exameSelecionado (val) {
      if (val) {
        this.addExame(val)
        this.exameSelecionado = null
      }
    }
  },
  mounted () {
    this.retornarFuncionarios()
    this.retornarAtendentes()
  },
  methods: {
    async retornarFuncionarios () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarFuncionarios(4)
        this.listaFuncionariosAtivos = response.data.filter(f => f.ativo)
      } catch (error) {
        console.error('Erro ao carregar médicos:', error)
      }
    },

    async retornarAtendentes () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarFuncionarios(3)
        this.listaAtendentesAtivos = response.data.filter(f => f.ativo)
      } catch (error) {
        console.error('Erro ao carregar atendentes:', error)
      }
    },

    async listarPacoteExames () {
      this.loadPacotes = true
      try {
        const response = await administradorUnidadeService.administradorUnidade.listarPacoteExames(
          this.$store.getters.usuario.idUnidade,
          this.sadt
        )
        this.pacotesExames = response.data
      } catch (error) {
        console.error('Erro ao carregar pacotes:', error)
      } finally {
        this.loadPacotes = false
      }
    },

    async listarExames (nome) {
      this.isLoading = true
      try {
        const response = await medicoService.medico.listarExamesPorNome(
          nome,
          this.sadt ? 'LABORATORIO' : 'CLINICA'
        )
        this.entries = response.data
      } catch (error) {
        console.error('Erro ao buscar exames:', error)
      } finally {
        this.isLoading = false
      }
    },

    addExame (item) {
      if (!this.listaExames.some(e => e.idExame === item.idExame)) {
        this.listaExames.push(item)
      }
    },

    async cadastrarPacoteExame () {
      if (this.$refs.form.validate()) {
        this.loadCadastro = true
        try {
          const response = await administradorUnidadeService.administradorUnidade.cadastrarPacoteExame(
            null,
            this.nomePacote,
            this.listaExames,
            this.$store.getters.usuario.idUnidade,
            this.sadt,
            true
          )

          if (response.status === 200) {
            this.cadastroSucesso = true
            this.isAddPacote = false
            this.nomePacote = ''
            this.listaExames = []
            this.listarPacoteExames()
          }
        } catch (error) {
          console.error('Erro ao cadastrar pacote:', error)
        } finally {
          this.loadCadastro = false
        }
      }
    },

    exibirEditarPacote (item) {
      this.pacoteSelecionado = JSON.parse(JSON.stringify(item))
      this.listaExames = [...item.exames]
      this.isEditarPacote = true
    },

    async editarPacoteExame () {
      if (this.$refs.formEdit.validate()) {
        this.loadEdit = true
        try {
          const response = await administradorUnidadeService.administradorUnidade.cadastrarPacoteExame(
            this.pacoteSelecionado._id,
            this.pacoteSelecionado.nome,
            this.listaExames,
            this.pacoteSelecionado.idUnidade,
            this.pacoteSelecionado.sadt,
            true
          )

          if (response.status === 200) {
            this.editarSucesso = true
            this.isEditarPacote = false
            this.listarPacoteExames()
          }
        } catch (error) {
          console.error('Erro ao editar pacote:', error)
        } finally {
          this.loadEdit = false
        }
      }
    },

    exibirVincularMedicos (item) {
      this.pacoteSelecionado = JSON.parse(JSON.stringify(item))
      this.medicosSelecionados = item.medicos ? [...item.medicos] : []
      this.isVincularMedicos = true
    },

    async cadastrarPacoteMedico () {
      this.loadVinculacao = true
      try {
        const response = await medicoService.medico.cadastrarPacoteExames(
          this.medicosSelecionados,
          this.pacoteSelecionado._id
        )

        if (response.status === 200) {
          this.vincularSucesso = true
          this.isVincularMedicos = false
          this.listarPacoteExames()
        }
      } catch (error) {
        console.error('Erro ao vincular médicos:', error)
      } finally {
        this.loadVinculacao = false
      }
    },

    async removerPacoteExame (pacote) {
      try {
        const response = await administradorUnidadeService.administradorUnidade.cadastrarPacoteExame(
          pacote._id,
          pacote.nome,
          pacote.exames,
          pacote.idUnidade,
          pacote.sadt,
          false
        )

        if (response.status === 200) {
          this.removerSucesso = true
          this.listarPacoteExames()
        }
      } catch (error) {
        console.error('Erro ao remover pacote:', error)
      }
    },

    cadastrarMedicoExame (item) {
      this.$router.push({
        name: 'cadastrarMedicoExame',
        params: { item }
      })
    },

    cadastrarMedicoServico (item) {
      this.$router.push({
        name: 'cadastrarMedicoServico',
        params: { item }
      })
    },

    alterarDadosMedico (item) {
      this.$router.push({
        name: 'alterarDadosMedico',
        params: { medico: item }
      })
    },

    cadastrarMedico () {
      this.$router.push({
        name: 'cadastrarMedicoUnidade',
        params: { listaMedicosCadastrados: this.listaFuncionariosAtivos }
      })
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  overflow: hidden;
}

.v-btn {
  text-transform: none;
  letter-spacing: normal;
}

.v-data-table >>> .v-data-table-header {
  background-color: #f5f5f5;
}

.v-alert {
  margin-bottom: 16px;
}

.v-tab {
  font-weight: 500;
}

@media (max-width: 960px) {
  .v-tab {
    font-size: 0.8rem;
  }
}

.v-list-item__action {
  margin-left: 8px;
}

.v-list-item__content {
  padding: 8px 0;
}
</style>
